import { SB } from '@play-co/replicant';

export const jankenSchema = {
  // Optional root — lazily initialized on first janken interaction.
  // Keeps state lightweight for users who never play janken.
  janken: SB.object({
    // Timestamp (ms) of the last daily reset. Compared against `now` using JST
    // calendar day equivalence to detect day rollover and reset dailyRewards to 0.
    // Undefined until the first daily reset runs.
    dailyStamp: SB.int().optional(),

    // Number of janken rewards earned today (resets on JST day boundary).
    // Capped at JANKEN_MAX_DAILY_REWARDS (5) — once reached, no more rewards
    // can be earned until the next calendar day.
    dailyRewards: SB.int().default(0),

    // Per-friend reward de-duplication.
    // Key: friendId, Value: timestamp (ms) when the last reward was granted for this friend.
    // Compared against `now` using JST calendar day equivalence to prevent
    // earning multiple rewards from the same friend on the same day.
    resolvedFriends: SB.map(SB.int()),

    // Per-challenge replay guard.
    // Key: `${challengeId}_${senderId}`, Value: timestamp when resolved.
    // Prevents duplicate OA notifications and reward grants when a user
    // re-taps the same challenge link multiple times.
    resolvedChallenges: SB.map(SB.int()),

    // Timestamp (ms) when the user first saw the janken tutorial (info popup).
    // Undefined until the tutorial auto-shows on first janken open.
    tutorialSeenAt: SB.int().optional(),

    // Sender-pending results waiting to be claimed.
    // When the receiver resolves a challenge, a pending result is stored in the
    // sender's state so they can see the outcome and claim their reward (if they won).
    // Key: `${challengeId}_${receiverId}`, Value: result metadata.
    pendingResults: SB.map(
      SB.object({
        // The challenge ID this result belongs to.
        // Stored explicitly to avoid parsing it from the map key.
        challengeId: SB.string(),

        // The user ID of the friend who played against the sender.
        receiverId: SB.string(),

        // Timestamp (ms) when the receiver resolved this challenge.
        // Used for expiry checks and display ordering.
        createdAt: SB.int(),

        // The opponent's pet species (e.g. 'dog', 'cat', 'starball').
        opponentSpecies: SB.string().optional(),

        // The opponent's display name (public profile name with locale fallback).
        opponentDisplayName: SB.string().optional(),
      }),
    ),
  }).optional(),
};
